<template>
  <div class="w-full px-3 py-2 flex" :class="classes">
    <Icon :size="36" name="Dacr" class="fill-gray-800 mr-3" />
    <div
      class="font-secondary text-[14px] leading-5 tablet-h:leading-[19px] tablet-h:text-[13px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <div class="mb-1 tablet-h:mb-0.5">
        Copyright all your original work and IP with Dacr! Easily get started by
        adding your files today.
      </div>
      <div class="text-[13px] tablet-h:text-[12px] opacity-50">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Notification } from '@/shared/graphql/legacy/generated'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed } from 'vue'
import { Icon } from '@dacr/ui'

const props = defineProps<{
  notification: Notification
}>()

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-900/10': !props.notification.read,
}))
</script>
